<template>
  <div class="user pane">
    <h3>{{ user.name }}</h3>
    <span
      v-for="role in userRoles"
      :key="role"
      :class="['role', role]">
      <i :class="['icon', roleIcon(role)]"></i>
      {{ role }}
    </span>
    <br /><br />
    <div class="details">
      <div v-if="user.created">
        <strong>Created:</strong>
        <span>{{ user.created.toDate() | moment('MMMM D YYYY') }}</span>
      </div>
      <div>
        <strong>Twitch ID:</strong>
        <span>{{ user.twitchId }}</span>
      </div>
      <div>
        <strong>Balance:</strong>
        <span>
          {{ balance }}
          <small v-if="balance !== user.balance" class="warning">
            &nbsp;
            <i class="icon fas fa-exclamation-triangle"></i>
            Transactions out of sync with user record
            ({{ user.balance }})
          </small>
        </span>
      </div>
      <div>
        <strong>Total earned:</strong>
        <span>{{ user.gained }}</span>
      </div>
      <div>
        <strong>Total spent:</strong>
        <span>{{ user.spent }}</span>
      </div>
      <div v-if="user.subscription">
        <strong>Subscription:</strong>
        <span v-if="user.subscription.tier > 0">
          <strong>Tier {{ user.subscription.tier }}</strong>
          <br />
          &ldquo;{{ user.subscription.name }}&rdquo;
          <br />
          <small>
            (Since {{ user.subscription.created.toDate() | moment('calendar') }}, expires on {{ user.subscription.expires.toDate() | moment('calendar') }})
          </small>
        </span>
        <span v-else>
          None
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import ApiHelper from '../mixins/ApiHelper'

export default {
  name: 'User',
  mixins: [ApiHelper],
  props: ['user', 'transactions'],

  computed: {
    userRoles () {
      const flags = Object.entries(this.user.flags || {})
        .filter(([ flag, pos ]) => pos)
        .map(([ flag ]) => flag)
      return flags
    },

    balance () {
      return this.transactions
        ? this.transactions.reduce((a, b) => a + b.amount, 0)
        : 0
    }
  },

  methods: {
    roleIcon (role) {
      switch (role) {
        case 'admin': return 'fas fa-crown'
        case 'moderator': return 'fas fa-gavel'
        case 'trusted': return 'fas fa-thumbs-up'
        case 'banned': return 'fas fa-skull-crossbones'
        default: return 'fas fa-question'
      }
    }
  }
}
</script>

<style scoped>
.user .details > div {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
}

.user .details > div > strong:first-child {
  width: 120px;
  flex-shrink: 0;
}

.user {
  padding: 1em;
}

.warning {
  color: orangered;
}
</style>
